"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@folio/stripes/core");
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * API is similar to ConfigManager
 */const SettingsFormContainer = _ref => {
  let {
    ConfigFormComponent,
    configName,
    getInitialValues: passedGetInitialValues,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    labelOverrides = {},
    moduleName,
    scope,
    // We don't use this currently but it's here for future reference
    ...rest
  } = _ref;
  const callout = (0, _core.useCallout)();
  const kintIntl = (0, _hooks.useKintIntl)(passedIntlKey, passedIntlNS);

  /*
    * It is important to pass a namespaceAppend because the same hook could be rendered
    * on the main App component. This means that in settings
    * (Which is rendered inside App itself, stripes behaviour)
    * the same query namespace would apply to the query in the config form, and also to
    * the App level hook call, resulting in an infinite loop.
    *
    * We avoid this by ensuring all calls from this component have (at least) an extra namespace key item
    */
  const {
    parsedSettings,
    settings
  } = (0, _hooks.useModConfigEntries)({
    moduleName,
    configName,
    namespaceAppend: ['SettingsFormContainer']
  });
  const {
    mutateAsync: editSettings
  } = (0, _hooks.useMutateModConfigEntry)({
    configName,
    moduleName,
    id: settings?.id
  });
  const onSubmit = values => {
    const setting = {
      ...settings,
      value: JSON.stringify(values),
      ...(moduleName ? {
        module: moduleName,
        configName
      } : {
        scope,
        key: configName
      })
    };
    editSettings(setting).then(() => {
      callout.sendCallout({
        message: kintIntl.formatKintMessage({
          fallbackMessage: 'stripes-smart-components.cm.success',
          id: 'settingSaveSuccess',
          intlKey: passedIntlKey,
          intlNS: passedIntlNS,
          overrideValue: labelOverrides?.settingSaveSuccess
        }),
        type: 'success'
      });
    });

    // At some point we might want to add a catch callout.
    // The current ConfigManager doesn't have one, so leaving for now
  };

  const getInitialValues = () => {
    let initialValues = parsedSettings;
    if (passedGetInitialValues) {
      initialValues = passedGetInitialValues(parsedSettings, settings);
    }
    return initialValues;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    style: {
      width: '100%'
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ConfigFormComponent, {
      initialValues: getInitialValues(),
      onSubmit: onSubmit,
      ...rest
    })
  });
};
SettingsFormContainer.propTypes = {
  ConfigFormComponent: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.func]),
  configName: _propTypes.default.string.isRequired,
  getInitialValues: _propTypes.default.func,
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  labelOverrides: _propTypes.default.object,
  moduleName: _propTypes.default.string.isRequired,
  scope: _propTypes.default.string
};
var _default = exports.default = SettingsFormContainer;